import React from "react";
import { MusicScale } from "../../../wasm/pkg/wasm";
import { AppContextType } from "../../AppContext";
import { printScaleRootLetter, printScaleShapeType } from "../../models/wasm.model";
import InfoCard from "../layout_reuse/InfoCard";
import "./MusicKeyGiantLetter.css";

interface Props {
  scale?: MusicScale;
}
interface State {}

export default class MusicKeyGiantLetter extends React.Component<Props, State> {
  declare context: React.ContextType<typeof AppContextType>;

  // What might the user want:
  // rule out invalid key (they can achieve this via notes)

  render() {
    const { scale } = this.props;
    const { isPreferMajor } = this.context.keySelectionOptions;
    const noteName = printScaleRootLetter(scale, isPreferMajor);
    const scaleShape = printScaleShapeType(scale, isPreferMajor);
    return (
      <InfoCard includesHeaderBar className="area-big-key">
        <div className="music-scale-giant-letter-frame">
          {noteName ? (
            <div className="music-scale-giant-letter">{noteName}</div>
          ) : (
            <div className="music-scale-none-placeholder">&lt;the key will appear here&gt;</div>
          )}
          <div className="music-scale-giant-scale-shape">{scaleShape}</div>
        </div>
      </InfoCard>
    );
  }
}

MusicKeyGiantLetter.contextType = AppContextType;
